<template>
	<modal ref="modal" size="modal-xl">
		<template #title>Member Information</template>
		<template #body>
			<div v-if="member!=null" class="row mb-3">
				<div class="col-md-12">
					<div class="form-group mb-4">
						<h4 class="text-center fw-bold">
							<span v-if="member.is_verified==1" class="text-success">VERIFICATION COMPLETE</span>
							<span v-else class="text-danger">NOT YET VERIFIED</span>
						</h4>
					</div>
				</div>
				<div class="col-md-7">
					<div class="form-floating mb-4">
						<div class="form-control">{{member.current_rank}}</div>
						<label class="form-label">Subscription</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member.fname}}</div>
						<label class="form-label">First Name</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member.mname}}</div>
						<label class="form-label">Middle Name</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member.lname}}</div>
						<label class="form-label">Last Name</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member.mobile}}</div>
						<label class="form-label">Mobile</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member.id_type??'None'}}</div>
						<label class="form-label">ID Type</label>
					</div>
					<div class="form-floating mb-4">
						<div class="form-control">{{member.id_type_number??'None'}}</div>
						<label class="form-label">ID Type Number</label>
					</div>
				</div>
				<div class="col-md-5">
					<div class="mb-4">
						<label class="fw-bold">Document Information <span v-if="member.is_docu_reupload==1" class="badge bg-warning">Re-uploaded</span></label>
						<div class="p-3 border">
							<div class="row">
								<div class="col-8">
									<span>Check Front ID</span>
								</div>
								<div class="col-4 text-end">
									<button type="button" @click="viewDocument(member.id_type_uploaded)" class="btn btn-outline-info btn-sm"><i class="fa fa-search me-1"></i>View ID</button>
								</div>
							</div>
						</div>
						<div class="p-3 border">
							<div class="row">
								<div class="col-8">
									<span>Check Back ID</span>
								</div>
								<div class="col-4 text-end">
									<button type="button" @click="viewDocument(member.id_type_back_uploaded)" class="btn btn-outline-info btn-sm"><i class="fa fa-search me-1"></i>View ID</button>
								</div>
							</div>
						</div>
						<div class="p-3 border">
							<div class="row">
								<div class="col-8">
									<span>Check Selfie with ID</span>
								</div>
								<div class="col-4 text-end">
									<button type="button" @click="viewDocument(member.id_type_selfie_uploaded)" class="btn btn-outline-info btn-sm"><i class="fa fa-search me-1"></i>View ID</button>
								</div>
							</div>
						</div>
					</div>
					<div v-if="member.is_verified==0" class="mb-3">
						<button @click="updateDocument()" type="button" class="btn btn-alt-danger btn-sm" :disabled="member.is_docu_rejected==1 || form.processing">
							<i v-if="!formDocu.processing" class="fa fa-times me-1"></i>
							<span v-else>
								<div class="spinner-border spinner-border-sm text-dark me-1" role="status" >
									<span class="sr-only mr-1">Please wait...</span>
								</div>
							</span>
							Reject ID
						</button>
					</div>
					<div >
						<label>Rejection Notes</label>
						<textarea v-model="formDocu.docu_remarks" class="form-control" style="height:150px;"></textarea>
						<div v-if="formDocu.errors.docu_remarks && (formDocu.docu_remarks=='' || formDocu.docu_remarks==null)" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ formDocu.errors.docu_remarks }}
						</div>
					</div>
				</div>
			</div>
			<div v-else class="p-5 text-center">
				<p class="h4 m-0">No Record Found</p>
			</div>
		</template>
		<template #footer>
			<span v-if="member!=null">
				<button v-if="member.is_verified==0"
					@click="verified"
					type="button"
					class="btn btn-alt-success"
					:disabled="form.processing"
				>
					<i v-if="!form.processing" class="fa fa-check-circle me-1"></i>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark me-1" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
					</span>
					<span>Verified</span>
				</button>
				<button v-if="member.is_verified==1 && member.invest_uid==null"
					@click="repostData"
					type="button"
					class="btn btn-alt-success"
					:disabled="formRepost.processing"
				>
					<i v-if="!formRepost.processing" class="fa fa-check-circle me-1"></i>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark me-1" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
					</span>
					<span>Repost</span>
				</button>
			</span>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				<i class="fa fa-times me-1"></i>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
	import { watch, ref } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';

	export default {
		props:{
			apiResponse : Object
		},
		setup(props){

			const modal 	= ref(null);
			const action 	= ref('verify');

			const member = ref(null);

			const docu_link = ref("");

			const form = useForm({
				member_uuid 		: null,
				is_docu_rejected 	: 0,
				is_docu_reupload 	: 0,
				is_verified 		: 1,
			});

			const formDocu = useForm({
				member_uuid 		: null,
				is_docu_rejected 	: 1,
				is_docu_reupload 	: 0,
				is_verified 	 	: 0,
				docu_remarks 	 	: null,
			});

			const formRepost = useForm({});

			const toggleModal = () => { modal.value.toggleModal(); };


			const setMember = (data)=>{ 
				member.value 			= data; 
				form.member_uuid 		= member.value.member_uuid; 
				formDocu.member_uuid 	= member.value.member_uuid; 
			}

			const viewDocument = (docu)=>{
				action.value = 'view';
				axios.get('view-document/'+docu)
				   	.then(res => {
				      window.open(res.data);
				   	})

			}

			const verified = ()=>{
				action.value 			= 'verify';
				
				form.put("verified/"+member.value.invest_uuid,{},{
					only:['approvals','api_response'],
				})
			}

			const updateDocument = ()=>{

				action.value 			= 'reject';

				formDocu.put("document/reject/"+member.value.invest_uuid,
					{},{
					only:['approvals','api_response'],
				})
			}

			const repostData = ()=>{
				action.value 			= 'repost';

				formRepost.put("repost/"+member.value.invest_uuid,
					{},{
					only:['approvals','api_response'],
				})
			}

			watch(()=>props.apiResponse, (value) => {
				if(value.result=="success")
				{
					
					if(action.value=='verify')
					{
						member.value.is_docu_rejected 	= 0;
						member.value.is_docu_reupload 	= 0;
						member.value.is_verified 		= 1;
					}

					if(action.value=='reject')
					{
						member.value.is_docu_rejected 	= 1;
						member.value.is_docu_reupload 	= 0;
						member.value.is_verified 		= 0;
					}

				}
			})

			return{
				action,
				docu_link,
				modal,
				form,
				formDocu,
				formRepost,
				toggleModal,
				member,
				setMember,
				viewDocument,
				updateDocument,
				verified,
				repostData,
			}
		}
	}

</script>